import { Thumbnail } from '@ukpostbox/frontend-framework/lib/Components/Images/Thumbnails/Thumbnail';
import { Tooltip } from '@ukpostbox/frontend-framework';
import { MailFileThumbnailCustomType } from '../Types/ThumbnailTypes';

function MailItemThumbnail(props: MailFileThumbnailCustomType) {
	return (
		<Tooltip disabled={!props.tooltipPreview} content={<img src={props.tooltipPreview} alt={props.fileName} />}>
			<Thumbnail
				description={props.fileName}
				src={props.linkToFile}
				onClickCallback={
					!props.tooltipPreview && props.onClickCallback
						? (e) => props.onClickCallback && props.onClickCallback(e, props.linkToFile)
						: undefined
				}
				size={props.size}
				blurHash={props.blurHash}
			/>
		</Tooltip>
	);
}

export { MailItemThumbnail };
